// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, ReactElement, useEffect } from "react";
import "./../styles/main.css";
import { ThemeProvider, createTheme } from "@mui/material";
import { AppRoutes } from "./AppRoutes";
import { useAuthContext } from "@asgardeo/auth-react";
import { LoadingPage } from "../pages/LoadingPage";

export const ThemedApp: FunctionComponent = (): ReactElement => {
  const { state } = useAuthContext();
  const leadPath = window.location.pathname.slice(1).split('/')[0];

  useEffect(() => {
    if (!sessionStorage.getItem('lastLocation') && leadPath === 'support') {
      sessionStorage.setItem('lastLocation', window.location.pathname);
    }
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#ff7300"
      },
    },
    typography: {
      fontFamily: "'Ruda', sans-serif"
    }
  });

  return (
    <ThemeProvider theme={theme}>
      {state.isLoading ? <LoadingPage />
        : <AppRoutes />}
    </ThemeProvider>
  );
};
